document.addEventListener("DOMContentLoaded", function() {
  const menuItems = document.querySelectorAll(
    ".main-header__bottom-wrapper li.has-dropdown"
  );
  // Mobile menu elements
  const mobileMenuTrigger = document.querySelector("[data-primary-toggle]");
  const mobileMenu = document.querySelector(".main-header__menus-wrapper");
  const header = document.querySelector(".main-header");
  let isMobileMenuOpen = false;

  // Mobile menu toggle functionality
  if (mobileMenuTrigger) {
    const openLabel =
      mobileMenuTrigger.getAttribute("data-label-open") ||
      "Otwórz menu nawigacyjne";
    const closeLabel =
      mobileMenuTrigger.getAttribute("data-label-close") ||
      "Zamknij menu nawigacyjne";

    mobileMenuTrigger.addEventListener("click", function() {
      isMobileMenuOpen = !isMobileMenuOpen;

      if (isMobileMenuOpen) {
        document.body.classList.add("scrollLock");
        mobileMenuTrigger.classList.add("isOpen");
        mobileMenuTrigger.setAttribute("aria-expanded", "true");
        mobileMenuTrigger.setAttribute("aria-label", closeLabel);

        if (header) {
          header.classList.add("isOpen");
          header.classList.add("main-header--sticked");
        }

        if (mobileMenu) {
          mobileMenu.classList.add("active");
        }
      } else {
        document.body.classList.remove("scrollLock");
        mobileMenuTrigger.classList.remove("isOpen");
        mobileMenuTrigger.setAttribute("aria-expanded", "false");
        mobileMenuTrigger.setAttribute("aria-label", openLabel);

        if (header) {
          header.classList.remove("isOpen");

          // Only remove sticked class if page is not scrolled
          if (window.scrollY === 0) {
            header.classList.remove("main-header--sticked");
          }
        }

        if (mobileMenu) {
          mobileMenu.classList.remove("active");
        }
      }
    });

    // Close mobile menu on Escape key
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && isMobileMenuOpen) {
        mobileMenuTrigger.click();
      }
    });

    // Close mobile menu on window resize if open
    window.addEventListener("resize", function() {
      if (isMobileMenuOpen && window.innerWidth >= 1080) {
        mobileMenuTrigger.click();
      }
    });
  }

  // Helper functions
  function positionSubmenu(button, submenu) {
    // Check if this is the first menu item (needs centering)
    const menuItem = button.closest("li");
    const isFirstItem = menuItem.matches(":first-of-type");

    if (isFirstItem && window.innerWidth >= 1080) {
      // Force submenu to be visible temporarily to get accurate width
      submenu.style.visibility = "hidden";
      submenu.style.display = "flex";
      submenu.removeAttribute("hidden");

      // Get parent li position (which has position: static)
      const menuItemRect = menuItem.getBoundingClientRect();
      // Get actual submenu width
      const submenuWidth = submenu.offsetWidth;
      // Calculate offset to center submenu on viewport
      const viewportCenter = window.innerWidth / 2;
      const submenuHalfWidth = submenuWidth / 2;
      // Calculate left offset from the parent li element
      const leftOffset = viewportCenter - submenuHalfWidth - menuItemRect.left;

      submenu.style.left = `${leftOffset}px`;

      // Reset visibility
      submenu.style.visibility = "";
      submenu.style.display = "";
    }
  }

  function openSubmenu(button, submenu) {
    button.setAttribute("aria-expanded", "true");
    submenu.removeAttribute("hidden");
    positionSubmenu(button, submenu);
  }

  function closeSubmenu(button, submenu) {
    button.setAttribute("aria-expanded", "false");
    submenu.setAttribute("hidden", "");
  }

  function closeAllSubmenus() {
    const allMenuItems = document.querySelectorAll(
      ".main-header__bottom-wrapper li.has-dropdown"
    );

    allMenuItems.forEach(function(item) {
      const btn = item.querySelector("button[aria-expanded]");
      const sub = item.querySelector('ul[role="menu"]');

      if (btn && sub) {
        closeSubmenu(btn, sub);
      }
    });
  }

  menuItems.forEach(function(menuItem) {
    const toggleButton = menuItem.querySelector("button[aria-expanded]");
    const submenu = menuItem.querySelector('ul[role="menu"]');
    const submenuLinks = submenu ? submenu.querySelectorAll("a") : [];
    const backButton = submenu
      ? submenu.querySelector(".submenu-back-button")
      : null;

    if (!toggleButton || !submenu) return;

    // Back button functionality (mobile only)
    if (backButton) {
      backButton.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeSubmenu(toggleButton, submenu);
        toggleButton.blur();
      });
    }

    // Desktop hover behavior
    if (window.innerWidth >= 1080) {
      menuItem.addEventListener("mouseenter", function() {
        openSubmenu(toggleButton, submenu);
      });

      menuItem.addEventListener("mouseleave", function() {
        closeSubmenu(toggleButton, submenu);
      });
    }

    // Click/Touch behavior for toggle button
    toggleButton.addEventListener("click", function(e) {
      e.preventDefault();
      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        closeSubmenu(toggleButton, submenu);
      } else {
        // Close other open submenus first
        closeAllSubmenus();
        openSubmenu(toggleButton, submenu);
      }
    });

    // Keyboard navigation - Space and Enter to toggle
    toggleButton.addEventListener("keydown", function(e) {
      if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
        e.preventDefault();
        const isExpanded =
          toggleButton.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          closeSubmenu(toggleButton, submenu);
        } else {
          closeAllSubmenus();
          openSubmenu(toggleButton, submenu);
          // Focus first submenu item
          if (submenuLinks.length > 0) {
            setTimeout(() => {
              submenuLinks[0].focus();
            }, 50);
          }
        }
      }

      // Escape to close submenu
      if (e.key === "Escape" || e.key === "Esc") {
        closeSubmenu(toggleButton, submenu);
        toggleButton.focus();
      }
    });

    // Arrow key navigation within submenu
    submenuLinks.forEach(function(link, index) {
      link.addEventListener("keydown", function(e) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const nextIndex = (index + 1) % submenuLinks.length;

          submenuLinks[nextIndex].focus();
        }

        if (e.key === "ArrowUp") {
          e.preventDefault();
          const prevIndex =
            (index - 1 + submenuLinks.length) % submenuLinks.length;

          submenuLinks[prevIndex].focus();
        }

        if (e.key === "Escape" || e.key === "Esc") {
          closeSubmenu(toggleButton, submenu);
          toggleButton.focus();
        }
      });
    });
  });

  // Close submenus when clicking outside
  document.addEventListener("click", function(e) {
    const isMenuClick = e.target.closest(
      ".main-header__bottom-wrapper li.has-dropdown"
    );

    if (!isMenuClick) {
      closeAllSubmenus();
    }
  });

  // Handle window resize
  let resizeTimer;

  window.addEventListener("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      closeAllSubmenus();
    }, 250);
  });

  // Mobile search panel functionality
  const searchToggleButton = document.querySelector(
    ".main-header__search-toggle"
  );
  const searchPanel = document.getElementById("mobile-search-panel");
  const topBar = document.querySelector(".main-header__top-wrapper");
  const mainWrapper = document.querySelector(".main-header__wrapper");
  let isSearchPanelOpen = false;

  if (searchToggleButton && searchPanel) {
    const openLabel =
      searchToggleButton.getAttribute("data-label-open") ||
      "Otwórz wyszukiwanie";
    const closeLabel =
      searchToggleButton.getAttribute("data-label-close") ||
      "Zamknij wyszukiwanie";
    const closeSearchButton = searchPanel.querySelector(
      ".main-header__close-search-toggle"
    );
    // Focus trap handler
    let focusTrapHandler = null;
    const activateFocusTrap = element => {
      const getFocusableElements = () =>
        Array.from(
          element.querySelectorAll(
            'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
          )
        ).filter(el => el.offsetParent !== null);

      focusTrapHandler = e => {
        if (e.key !== "Tab") return;

        const focusableElements = getFocusableElements();

        if (focusableElements.length === 0) return;

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      };

      document.addEventListener("keydown", focusTrapHandler);
    };

    const deactivateFocusTrap = () => {
      if (focusTrapHandler) {
        document.removeEventListener("keydown", focusTrapHandler);
        focusTrapHandler = null;
      }
    };

    searchToggleButton.addEventListener("click", function() {
      isSearchPanelOpen = !isSearchPanelOpen;

      console.log("Toggling search panel:", isSearchPanelOpen);

      if (isSearchPanelOpen) {
        // Open search panel
        searchToggleButton.classList.add("isOpen");
        searchToggleButton.setAttribute("aria-expanded", "true");
        searchToggleButton.setAttribute("aria-label", closeLabel);
        searchPanel.removeAttribute("hidden");
        searchPanel.classList.add("active");

        // Add sticked class to header
        if (header) {
          header.classList.add("main-header--sticked");
        }

        // Hide top bar
        if (topBar) {
          topBar.classList.add("hidden");
        }

        // Hide main wrapper
        if (mainWrapper) {
          mainWrapper.classList.add("hidden");
        }

        // Activate focus trap
        activateFocusTrap(searchPanel);

        // Focus on search input
        setTimeout(() => {
          const searchInput = searchPanel.querySelector("input[type='search']");

          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      } else {
        // Close search panel
        searchToggleButton.classList.remove("isOpen");
        searchToggleButton.setAttribute("aria-expanded", "false");
        searchToggleButton.setAttribute("aria-label", openLabel);
        searchPanel.setAttribute("hidden", "");
        searchPanel.classList.remove("active");

        // Remove sticked class from header only if page is not scrolled
        if (header && window.scrollY === 0) {
          header.classList.remove("main-header--sticked");
        }

        // Show top bar
        if (topBar) {
          topBar.classList.remove("hidden");
        }

        // Show main wrapper
        if (mainWrapper) {
          mainWrapper.classList.remove("hidden");
        }

        // Deactivate focus trap
        deactivateFocusTrap();
      }
    });

    // Close button inside search panel
    if (closeSearchButton) {
      closeSearchButton.addEventListener("click", function() {
        if (isSearchPanelOpen) {
          searchToggleButton.click();
        }
      });
    }

    // Close search panel on Escape key
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && isSearchPanelOpen) {
        searchToggleButton.click();
      }
    });

    // Close search panel on window resize if open
    window.addEventListener("resize", function() {
      if (isSearchPanelOpen && window.innerWidth >= 1080) {
        searchToggleButton.click();
      }
    });
  }
});
